// extracted by mini-css-extract-plugin
module.exports = {"form":"locale-selector_form__jIklr","input-and-btn":"locale-selector_input-and-btn__EZqUd","selector":"locale-selector_selector__hYwUe","block":"locale-selector_block__snVYH"};